/** Estilo e tooltip compartilhados dos gráficos (recharts) de GAM > Anunciantes. */
import { fmtAdv } from './format';

export const AXIS_TICK = { fontSize: 11, fill: 'currentColor' };
export const AXIS_LINE = { stroke: '#64748b', strokeOpacity: 0.3 };
export const GRID = { strokeDasharray: '2 4', stroke: '#64748b', strokeOpacity: 0.18 };

export const COLORS = {
    revenue: '#10b981',
    ecpm: '#3b82f6',
    impressions: '#8b5cf6',
    clicks: '#f59e0b',
    ctr: '#ec4899',
    active_view: '#14b8a6',
    requests: '#64748b',
    previous: '#94a3b8',
    ma7: '#f97316',
};

export const SERIES_PALETTE = ['#10b981', '#3b82f6', '#8b5cf6', '#f59e0b', '#ec4899', '#14b8a6', '#f97316', '#84cc16', '#06b6d4', '#a855f7'];
export const OTHERS_COLOR = '#64748b';

const USD_KEYS = new Set(['revenue', 'ecpm', 'prev_revenue', 'prev_ecpm', 'ma7_revenue', 'ma7_ecpm', 'avg_ecpm']);
const PCT_KEYS = new Set(['ctr', 'active_view', 'fill_rate', 'prev_ctr', 'prev_active_view', 'share_pct']);

export function formatByKey(key: string, value: number): string {
    if (USD_KEYS.has(key)) return fmtAdv.usd(value);
    if (PCT_KEYS.has(key)) return fmtAdv.pct(value);
    return fmtAdv.num(value);
}

/** Tooltip escuro (padrão da Dashboard); formata pelo dataKey e mostra a data dd/MM/yyyy. */
export function ChartTooltip({ active, payload, label, formatKey }: any) {
    if (!active || !payload?.length) return null;
    const fmtKey = formatKey || formatByKey;
    return (
        <div className="rounded-lg border border-slate-700 bg-slate-800 p-3 text-white shadow-xl">
            <p className="mb-2 text-xs font-semibold">{/^\d{4}-\d{2}-\d{2}/.test(String(label)) ? fmtAdv.date(String(label)) : label}</p>
            {payload.map((entry: any, index: number) => (
                <p key={index} className="flex items-center gap-2 text-xs">
                    <span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: entry.color || entry.fill }} />
                    <span className="opacity-80">{entry.name}:</span>
                    <span className="font-semibold tabular-nums">{fmtKey(String(entry.dataKey), Number(entry.value) || 0)}</span>
                </p>
            ))}
        </div>
    );
}

export function ChartCard({ title, subtitle, children, right }: { title: string; subtitle?: string; children: React.ReactNode; right?: React.ReactNode }) {
    return (
        <div className="rounded-lg border border-border bg-card p-4 md:p-5">
            <div className="mb-4 flex flex-wrap items-start justify-between gap-2">
                <div>
                    <p className="text-[11px] font-medium uppercase tracking-[0.12em] text-muted-foreground">{title}</p>
                    {subtitle && <p className="mt-0.5 text-[11px] text-muted-foreground/80">{subtitle}</p>}
                </div>
                {right}
            </div>
            <div className="text-muted-foreground">{children}</div>
        </div>
    );
}

/** Chip liga/desliga de uma série do gráfico, com explicação no title. */
export function SeriesToggle({ label, active, onChange, color, hint }: { label: string; active: boolean; onChange: (on: boolean) => void; color?: string; hint?: string }) {
    return (
        <button
            type="button"
            aria-pressed={active}
            title={hint}
            onClick={() => onChange(!active)}
            className={`flex items-center gap-1.5 rounded border px-2 py-1 text-[10px] font-medium uppercase tracking-wider transition-colors ${
                active ? 'border-foreground/40 bg-accent text-foreground' : 'border-border text-muted-foreground hover:bg-accent hover:text-foreground'
            }`}
        >
            {color && <span className={`inline-block h-2 w-2 rounded-full ${active ? '' : 'opacity-40'}`} style={{ backgroundColor: color }} />}
            {label}
        </button>
    );
}

/** Preferência booleana persistida (toggles de gráfico). */
export function readToggle(key: string, fallback: boolean): boolean {
    try {
        const raw = localStorage.getItem(key);
        return raw == null ? fallback : raw === '1';
    } catch {
        return fallback;
    }
}

export function storeToggle(key: string, value: boolean): void {
    try {
        localStorage.setItem(key, value ? '1' : '0');
    } catch {
        /* sem storage */
    }
}

export function ChartEmpty({ height = 280 }: { height?: number }) {
    return (
        <div style={{ height }} className="flex items-center justify-center text-sm text-muted-foreground">
            Sem dados para exibir
        </div>
    );
}
